import { Container } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';

const IMG_NAVE_NUEVA_URL = new URL("../../img/bienvenida/nave.jpg", import.meta.url).href;
// const IMG_NAVE_ANTIGUA_URL = new URL("../../img/bienvenida/nave_antigua.jpg", import.meta.url).href;
const IMG_INTERIOR_1_URL = new URL("../../img/bienvenida/interior_nave_1.jpg", import.meta.url).href;
const IMG_INTERIOR_2_URL = new URL("../../img/bienvenida/interior_nave_2.jpg", import.meta.url).href;
const INTERVAL_IN_MILISECONDS = 2000;

const Empresa = () => {
  return (
    <Container className="py-5">
      <h1 className="mb-4">Sobre la Empresa</h1>

      <p>
        Goyanes Somoza es una empresa gallega especializada en la distribución de materiales, herrajes y soluciones para carpintería, mobiliario y decoración. Con sede en Sarria (Lugo), la compañía cuenta con una amplia trayectoria en el sector de la madera y el mueble, ofreciendo productos y servicios orientados tanto a profesionales como a fabricantes e instaladores.
      </p>

      <p>
        Fundada en la década de los 90, Goyanes Somoza nace de la experiencia de una empresa familiar con más de 30 años de tradición en la fabricación de mobiliario. A lo largo de su evolución, ha combinado conocimiento técnico, innovación y servicio para convertirse en un referente en el suministro de materiales para carpintería y equipamiento de muebles y cocinas.
      </p>

      <p>
        La empresa dispone de modernas instalaciones y más de 5.000 m² de almacén en el Polígono Industrial O Morelle, en Sarria, desde donde distribuye una amplia gama de productos relacionados con:
      </p>

      <h3>Productos</h3>
      <ul>
        <li>Herrajes para muebles y cocinas</li>
        <li>Tableros y materiales de madera</li>
        <li>Puertas y armarios</li>
        <li>Iluminación técnica</li>
        <li>Equipamiento comercial</li>
        <li>Herramientas y consumibles</li>
        <li>Soluciones de revestimiento</li>
      </ul>

      <h3>Además de la distribución de materiales, Goyanes Somoza ofrece servicios especializados como:</h3>

      <ul>
        <li>Corte y canteado de piezas</li>
        <li>Fresado y mecanizado CNC</li>
        <li>Mecanizado de puertas</li>
        <li>Soluciones técnicas para instalaciones comerciales</li>
      </ul>

      <p>
        Gracias a su experiencia, atención personalizada y apuesta constante por la calidad, Goyanes Somoza trabaja cada día para ofrecer soluciones eficientes y adaptadas a las necesidades del sector de la carpintería y el mueble.
      </p>
      <Carousel className="carrousel">
            <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
            <img
                className="paginaPrincipalImagen"
                src={IMG_NAVE_NUEVA_URL}
                alt="First slide"
            />
            </Carousel.Item>
            {/* <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
            <img
                className="paginaPrincipalImagen"
                src={IMG_NAVE_ANTIGUA_URL}
                alt="First slide"
            />
            </Carousel.Item> */}
            <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
            <img
                className="paginaPrincipalImagen"
                src={IMG_INTERIOR_1_URL}
                alt="First slide"
            />
            </Carousel.Item>
            <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
            <img
                className="paginaPrincipalImagen"
                src={IMG_INTERIOR_2_URL}
                alt="First slide"
            />
            </Carousel.Item>
        </Carousel>
    </Container>
  );
};

export default Empresa;
